import { render, staticRenderFns } from "./SettingsRegionalModule.vue?vue&type=template&id=d5721970&"
import script from "./SettingsRegionalModule.vue?vue&type=script&lang=js&"
export * from "./SettingsRegionalModule.vue?vue&type=script&lang=js&"
import style0 from "./SettingsRegionalModule.vue?vue&type=style&index=0&id=d5721970&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports